var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 13.7564,
    cy: 13.5855,
    r: 13.5855,
    fill: "#F9F9F7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-fb-simple 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5011 19.7065V14.3174H10.6875V12.2172H12.5011V10.6683C12.5011 8.87084 13.5989 7.89209 15.2023 7.89209C15.9704 7.89209 16.6305 7.94927 16.8229 7.97483V9.85328L15.7108 9.85379C14.8388 9.85379 14.6699 10.2682 14.6699 10.8763V12.2172H16.7497L16.4789 14.3174H14.6699V19.7065H12.5011Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1abeb44719ae7ea5f34306bf37304998.svg";
export { ForwardRef as ReactComponent };